import React from 'react';
import { useQuery } from '@common/hooks';
import { PROFILE_STATUS_SETUP_DRAWER_ASSIGNMENT_QUERY } from '@working-experience/graphql';
import { ErrorHandler } from '@common/components';
import { ProfileStatusSetupBaseDrawer } from '@working-experience/components';

export function ProfileStatusSetupAssignmentDrawer({
  open,
  onClose,
  assignmentId,
  dnr: doNotRehireQueryParam,
}: {
  open: boolean;
  onClose: () => void;
  assignmentId?: string;
  dnr?: boolean;
}) {
  const {
    loading: queryAssignmentLoading,
    error: queryAssignmentError,
    data: queryAssignmentData,
  } = useQuery(PROFILE_STATUS_SETUP_DRAWER_ASSIGNMENT_QUERY, {
    variables: { id: assignmentId || '' },
    skip: !assignmentId,
  });

  if (queryAssignmentError) {
    return (
      <ErrorHandler
        messageType="contextual"
        error={queryAssignmentError}
        log="ProfileStatusSetupAssignmentDrawer"
      />
    );
  }

  return (
    <ProfileStatusSetupBaseDrawer
      open={open}
      onClose={onClose}
      entity={queryAssignmentData?.staffingRequestAssignment}
      assignmentId={assignmentId}
      loading={queryAssignmentLoading}
      doNotRehireQueryParam={doNotRehireQueryParam}
      assignmentCancellationReason={
        queryAssignmentData?.staffingRequestAssignment?.cancelledDetail ||
        undefined
      }
    />
  );
}
